import { useAppContext } from '../../context/AppContext.js';
import "./style.css";
import api from "../../services/api";
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import FloatingMenu from "../../componente/menuflutuante/index.jsx"; // Componente do menu flutuante
import TopBar from "../../componente/topbar/index.jsx";
import ModalSolicitacao from "react-modal";
import LoadingScreen from "../../componente/aguarde";

function Humor() {
  const { DateTime } = require("luxon");
  const navigate = useNavigate();
  const { codcolaborador, selectedCompany, codassinante, accessKey, nomeDoColaborador, fotoPerfil } = useAppContext(); // Acessa os dados do contexto
  const [entryType, setEntryType] = useState("");
  const [tipoEntradaDefinido, setTipoEntradaDefinido] = useState(false);
  const [loading, setLoading] = useState(false);

  // Função para calcular o primeiro dia do mês
  const getFirstDayOfMonth = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
  };

  // Função para calcular a data atual
  const getCurrentDate = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
  };

  const [startDate, setStartDate] = useState(getFirstDayOfMonth);
  const [endDate, setEndDate] = useState(getCurrentDate);
  const [entries, setEntries] = useState([]);
  const [totalhora, setTotalHora] = useState("");
  const [solicitacaoModalOpen, setSolicitacaoModalOpen] = useState(false);
  const [edtdtlancamento, setedtdtlancamento] = useState("");
  const [edtmomento, setedtmomento] = useState("");
  const [edttipohumor, setedttipohumor] = useState("");
  const [edtjustificativa, setedtjustificativa] = useState("");

  const dt = new Date();
  const date =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  let time =
    dt.getHours().toString().padStart(2, "0") +
    ":" +
    dt.getMinutes().toString().padStart(2, "0");
  let dtcadastro = date + "T" + time;

  const feelings = [
    { emoji: "🥳", text: "Tô eufórico/vibrante" },
    { emoji: "🤩", text: "Tô incrível/maravilhoso(a)" },
    { emoji: "😃", text: "Tô alegre" },
    { emoji: "😊", text: "Tô bem" },
    { emoji: "😐", text: "Tô neutro/indiferente" },
    { emoji: "😢", text: "Tô triste" },
    { emoji: "😬", text: "Tô ansioso(a)" },
    { emoji: "😱", text: "Tô com medo" },
    { emoji: "😡", text: "Tô com raiva" },
    { emoji: "🥱", text: "Cansado" },
    { emoji: "🤧", text: "Doente" },
    { emoji: "😇", text: "Grato" },
  ];

  const fetchEntries = () => {
    api
      .get(`v1/cadastro/colaborador/humor`, {
        params: {
          codcolaborador,
          startdate: startDate,
          enddate: endDate,
        },
        headers: { Authorization: `Bearer ${accessKey}` },
      })
      .then((response) => setEntries(response.data))
      .catch((err) => console.log("Erro ao buscar entradas: ", err));
  };

  const fetchSaldoHora = () => {
    api
      .get(`v1/cadastro/colaborador/saldohora`, {
        params: {
          codcolaborador,
          startdate: startDate,
          enddate: endDate,
        },
        headers: { Authorization: `Bearer ${accessKey}` },
      })
      .then((response) => setTotalHora(response.data.totalhorastrabalhadas))
      .catch((err) => console.log("Erro ao buscar entradas: ", err));
  };

  async function handleClick(feelingText) {
    setLoading(true);

    try {
      await api.post(
        "v1/cadastro/colaborador/humor",
        {
          tipohumor: feelingText,
          momento: entryType,
          dtlancamento: dtcadastro,
          excluido: "N",
          codcolaborador,
          codassinante,
          solicitacao: "N",
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      );
      alert(`Sentimento "${feelingText}" enviado com sucesso!`);
      navigate('/principal');
    } catch (err) {
      console.log("Ops! Ocorreu um erro: " + err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchEntries();
    fetchSaldoHora();
  }, [startDate, endDate]);

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  async function Salvar() {
    if (edttipohumor === '') {
      alert("Informe o tipo de humor");
    } else if (edtmomento === '') {
      alert("Informe o momento");
    } else if (edtdtlancamento === '') {
      alert("Informe a data e hora");
    } else if (edtjustificativa === '') {
      alert("Informe a justificativa");
    } else {
      try {
        setLoading(true);

        await api.post(
          "/v1/cadastro/colaborador/solicitacaoponto",
          {
            tipohumor: edttipohumor,
            momento: edtmomento,
            dtlancamento: edtdtlancamento,
            codcolaborador,
            excluido: "N",
            codassinante,
            codempresa: selectedCompany,
            solicitacao: "S",
            justificativa: edtjustificativa
          },
          {
            headers: {
              Authorization: `Bearer ${accessKey}`,
            },
          }
        );
        setSolicitacaoModalOpen(false);
      } catch (err) {
        console.log("Ops! Ocorreu um erro: " + err);
      } finally {
        setLoading(false);
      }
    }
  }

  const handleTipoHumorChange = (event) => {
    setedttipohumor(event.target.value); // Armazena "null" para todas as empresas
  };

  function OpenModal() {
    setedtdtlancamento("");
    setedtmomento("");
    setedttipohumor("");

    setSolicitacaoModalOpen(true);
  }

  return (<>
    <TopBar nomeColaborador={nomeDoColaborador} foto={fotoPerfil} />
    <FloatingMenu />
    {loading && <LoadingScreen />}
    <div className="app-container">
      {tipoEntradaDefinido ?
        <div className="containerhumor">
          {feelings.map((feeling, index) => (
            <div
              key={index}
              onClick={() => handleClick(feeling.text)}
              className="feeling-box"
            >
              <div className="emoji">{feeling.emoji}</div>
              <div className="text">{feeling.text}</div>
            </div>
          ))}
        </div>
        :
        <div className="app-container">
          <ModalSolicitacao
            isOpen={solicitacaoModalOpen}
            onRequestClose={() => setSolicitacaoModalOpen(false)}
            overlayClassName="modal-overlay"
            className="modal-content modal-lg">

            <div className="modal-header">
              <h2>Solicitação de Ajuste de Ponto</h2>
              <button type="button" className="btn-close" onClick={() => setSolicitacaoModalOpen(false)}></button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <label htmlFor="dtlancamento" className="form-label">
                    Dt. Lançamento
                  </label>
                  <input
                    type="datetime-local"
                    id="dtlancamento"
                    className="form-control"
                    placeholder="Dt. Lançamento"
                    value={edtdtlancamento}
                    onChange={(e) => setedtdtlancamento(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12">
                  <div>
                    <label htmlFor="momento" className="form-label">
                      Momento
                    </label>
                    <br />
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="momento"
                        value="E"
                        onChange={(e) => setedtmomento(e.target.value)}
                        checked={edtmomento === "E"}
                      />
                      <label
                        className="form-check-label"
                        for="inlineRadio1"
                      >
                        Entrada
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="momento"
                        value="S"
                        onChange={(e) => setedtmomento(e.target.value)}
                        checked={edtmomento === "S"}
                      />
                      <label className="form-check-label" htmlfor="momento2">
                        Saída
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <label htmlFor="tipohumor" className="form-label">
                    Tipo de Humor
                  </label>
                  <select className="form-select" value={edttipohumor || '0'} onChange={handleTipoHumorChange}>
                    <option value="0">Selecione o humor</option>
                    <option value="Tô eufórico/vibrante">Tô eufórico/vibrante</option>
                    <option value="Tô incrível/maravilhoso(a)">Tô incrível/maravilhoso(a)</option>
                    <option value="Tô alegre">Tô alegre</option>
                    <option value="Tô bem">Tô bem</option>
                    <option value="Tô neutro/indiferente">Tô neutro/indiferente</option>
                    <option value="Tô triste">Tô triste</option>
                    <option value="Tô ansioso(a)">Tô ansioso(a)</option>
                    <option value="Tô com medo">Tô com medo</option>
                    <option value="Tô com raiva">Tô com raiva</option>
                  </select>
                </div>
              </div>

              <div className='row'>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <label htmlFor="justificativa" className="form-label">
                    Justificativa
                  </label>
                  <input
                    type="text"
                    id="justificativa"
                    className="form-control"
                    placeholder="Justificativa"
                    value={edtjustificativa}
                    onChange={(e) => setedtjustificativa(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='modal-footer'>
              <button type="button" className="btn btn-danger" onClick={() => setSolicitacaoModalOpen(false)}>
                Fechar
              </button>
              <button type="button" className="btn btn-success" onClick={Salvar}>
                Salvar
              </button>
            </div>
          </ModalSolicitacao>

          <div className='row'>
            <div className='col-4 mt-3'>
              <label htmlFor="">Saldo: <h5>{totalhora}</h5></label>
            </div>
            <div className="col-8 radio-buttons">
              <label className={`radio-option ${entryType === "E" ? "selected" : ""}`}>
                <input
                  type="radio"
                  name="entryType"
                  value="E"
                  checked={entryType === "E"}
                  onChange={(e) => { setEntryType(e.target.value); setTipoEntradaDefinido(true); }}
                />
                Entrada
              </label>
              <label className={`radio-option ${entryType === "S" ? "selected" : ""}`}>
                <input
                  type="radio"
                  name="entryType"
                  value="S"
                  checked={entryType === "S"}
                  onChange={(e) => { setEntryType(e.target.value); setTipoEntradaDefinido(true); }}
                />
                Saída
              </label>
            </div>
          </div>

          <div className='row'>
            <button type='button' className='col-12 btn btn-primary w-100' onClick={OpenModal}>Solicitar Ajuste de Ponto</button>
          </div>

          <div className="filters">
            <label className="form-label">
              Início:
              <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            </label>
            <label className="form-label">
              Fim:
              <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            </label>
          </div>

          <div className="row tabela">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Momento</th>
                  <th>Data/Hora</th>
                  <th>Humor</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry, index) => (
                  <tr key={index}>
                    <td>{entry.momento}</td>
                    <td>{FormataDataHora(entry.dtlancamento)}</td>
                    <td>{entry.tipohumor}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={3}>Quantidade de Registros: {entries.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>}
    </div>
  </>
  );
}

export default Humor;